<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h3>Nulstil adgangskode</h3>
      <img
        id="profile-img"
        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
        class="profile-img-card mt-3"
      />
      <form @submit.prevent="resetPassword">
        <div class="form-group">
          <label for="password">Adgangskode</label>
          <input
            name="password"
            id="password"
            type="password"
            class="form-control"
            v-model="password"
          />
        </div>
        <div class="form-group">
          <label for="confirmPassword">Bekræft adgangskode</label>
          <input
            name="confirmPassword"
            id="confirmPassword"
            type="password"
            class="form-control"
            v-model="confirmPassword"
          />
        </div>

        <div class="form-group mt-3">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            <span>Skift adgangskode</span>
          </button>
        </div>

        <div class="form-group mt-3">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AuthService from '../services/auth.service';

export default {
  name: 'Reset',
  components: {},
  data() {
    return {
      resetToken: '',
      password: '',
      confirmPassword: '',
      loading: false,
      message: '',
    };
  },
  created() {
    const t = this.$route.query.token;
    if (t === undefined || t === '') {
      window.location = '/';
    }
    this.token = t;
  },
  computed: {
    loggedIn() {
      const userData = localStorage.getItem('user');
      return userData !== undefined;
    },
  },
  methods: {
    resetPassword() {
      if (this.password !== this.confirmPassword) {
        alert('De to adgangskoder stemmer ikke overens. Forsøg igen.');
        return;
      }
      this.loading = true;

      AuthService.resetPassword(this.token, this.password)
        .then(() => {
          window.location = '/';
        })
        .catch(() => {
          this.loading = false;
          this.message =
            'Der opstod en fejl. Kontakt KL hvis fejlen fortsætter.';
        });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
